
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.787 0A1.8 1.8 0 000 1.791v10.857c0 .98.808 1.785 1.783 1.791l1.799.012.006 2.885a.666.666 0 001.064.531l4.565-3.408 6.998-.02A1.802 1.802 0 0018 12.65V1.79A1.8 1.8 0 0016.213 0H1.787zm0 1.332h14.426c.262 0 .455.193.455.459v10.857a.444.444 0 01-.457.46l-7.219.019a.666.666 0 00-.396.133l-3.678 2.746-.004-2.219a.666.666 0 00-.664-.664l-2.459-.016a.444.444 0 01-.459-.459V1.791c0-.266.193-.459.455-.459z","font-family":"sans-serif","overflow":"visible","paint-order":"markers stroke fill"}}),_c('path',{attrs:{"d":"M9 2.125a2.442 2.442 0 00-2.434 2.433c0 .828.42 1.56 1.057 2-.373.16-.68.382-.916.649-.492.56-.726 1.332-.726 2.195v2.272l.322.131a.73.73 0 00.278.055h4.838a.73.73 0 00.278-.055l.322-.131V9.4c0-.862-.234-1.634-.726-2.194a2.524 2.524 0 00-.916-.648 2.435 2.435 0 001.057-2A2.442 2.442 0 009 2.124zm0 1.043c.774 0 1.39.616 1.39 1.39 0 .775-.616 1.391-1.39 1.391-.774 0-1.39-.616-1.39-1.39 0-.775.616-1.391 1.39-1.391zM9 7.34c.806 0 1.231.24 1.509.555.284.324.467.833.467 1.507v1.415H7.024V9.402c0-.674.183-1.183.467-1.507C7.77 7.58 8.194 7.34 9 7.34z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    